module.exports = __webpack_public_path__ + "static/media/notification.15ef80ac.mp3";